<div class="chat-head" [@chatHeadAnimation]="chatHeadState" [@chatHeadMoveAnimation]="isFixedLeft? (showBTNOptions && isFixedLeft ? 'moved' : 'default') : ''"  #chatHead [ngStyle]="{'display': isVisible ? 'block' : 'none'}" (click)="onBubbleTap()">

  <div class="th-btn-options" [ngClass]="{'in-play-state':(showLeaderBoard) }"   [@toggleOptions]="{ value: showBTNOptions && !showLeaderBoard  ? 'expanded' : showBTNOptions && showLeaderBoard  ?  'expanded-280' : 'collapsed', params: { leftPosition: isFixedLeft ? '180px' : '0px' } }">
    <div class="btn-option league">
      <img src="assets/img/leagues/league-logo1.svg" (click)="openLeague()"/>
    </div>
    <p class="league-txt">{{'LEAGUE' | translate}}</p>
    <div class="btn-option th" (click)="playTH()">
      <img src="assets/img/treasure_hunt/gold-coins.svg"/>
    </div>
    <p class="th-txt">{{'TREASURE_HUNT.HUNT' | translate}}</p>
    <div class="btn-option leaderboard" (click)="THleaderboard()" *ngIf="showLeaderBoard">
      <img src="assets/img/treasure_hunt/leaderboard/thleadercup.svg"/>
    </div>
    <p *ngIf="showLeaderBoard" class="leaderboard-txt">Leaderboard</p>
  </div>


  <lottie-player *ngIf="!showTHchest" src="assets/img/treasure_hunt/banner/th_coming_soon.json" background="transparent" speed="1"  loop autoplay></lottie-player>
  <lottie-player *ngIf="showTHchest" src="assets/img/treasure_hunt/banner/treasure_chest.json" background="transparent" speed="1"  loop autoplay></lottie-player>
  <div class="bubble-info">
    <p *ngIf="!showTeamInfo && showBannerText" @bannerTextAnimation >
      {{bannerText | translate}}
    </p>
  </div>

  <div *ngIf="showTHchest" class="bubble-play" ><!--@TODO (click)="playTH()"-->
    <p [ngClass]="{'txt-end-count': !showPlayIcon}">
      {{bannerText | translate}}
    </p>
    <img *ngIf="showPlayIcon && userHuntType?.icon" [class]="userHuntType?.color" [src]="userHuntType?.icon"/>
  </div>
  <div *ngIf="showTeamInfo" class="team-info">
    <p class="animated-txt" *ngIf="!userTeamName"> {{animateViewText}}</p>
    <div *ngIf="userTeamName" class="team-detail">
      <img [src]="userHuntType.icon"/>
      <p class="team-name">{{userTeamName}}</p>
    </div>
  </div>

</div>


<div *ngIf="showMysteryBox" class="chat-head" [@chatHeadAnimation]="chatHeadState"   #chatHead [ngStyle]="{'display': !isVisible ? 'block' : 'none'}" (click)="end_hunt()" >
  <!-- <div class="bubble-info">
    <p *ngIf="showMysteryBox"  @bannerTextAnimation >
      {{'TREASURE_HUNT_MYSTERY_BOX'}}
    </p>
  </div> -->
  <div *ngIf="showMysteryBox" >
    <img  class="mystery_box_img"  src="assets/img/treasure_hunt/mystery_box.svg"/>
  </div>

  <div class="bubble-info">
    <p *ngIf="!showTeamInfo && showBannerText" @bannerTextAnimation >
      {{bannerText | translate}}
    </p>
  </div>

  <div class="bubble-play" >
    <p class="txt-end-count">
        {{showMysterBoxBannerText}}
    </p>
  </div>
</div>

